export const Services = {
	DefaultGraphQLServices: 'DefaultGraphQLServices',
	ChatGptService: 'ChatGptService',
} as const;
